import { render, staticRenderFns } from "./ReviewDetail.vue?vue&type=template&id=533a9be9&scoped=true&lang=html&"
import script from "./ReviewDetail.vue?vue&type=script&lang=coffee&"
export * from "./ReviewDetail.vue?vue&type=script&lang=coffee&"
import style0 from "./ReviewDetail.vue?vue&type=style&index=0&id=533a9be9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533a9be9",
  null
  
)

component.options.__file = "ReviewDetail.vue"
export default component.exports